import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";

const campaignSteps = [
    {
        label: "Informações básicas",
        number: 1
    },
    {
        label: "Período e Agendamento",
        number: 2
    },
    {
        label: "Público Alvo(Listagem)",
        number: 3
    },
    {
        label: "Regras de envio",
        number: 4
    },
    {
        label: "Canais e Modelos de Mensagem",
        number: 5
    }
];

export {
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    campaignSteps
}